export class HMDGoal {
  nrrToGoal: string;

  nrr: string;

  nrrGoal: string;

  nrrToGoalStatus: string;

  nrrToGoalThreshold: number;

  constructor({
    nrrToGoal,
    nrr,
    nrrGoal,
    nrrToGoalStatus,
    nrrToGoalThreshold,
  }: Record<string, any>) {
    this.nrrToGoal = nrrToGoal;
    this.nrr = nrr;
    this.nrrGoal = nrrGoal;
    this.nrrToGoalStatus = nrrToGoalStatus;
    this.nrrToGoalThreshold = nrrToGoalThreshold;
  }
}

export const EmptyHMDGoal: HMDGoal = {
  nrrToGoal: '',
  nrr: '',
  nrrGoal: '',
  nrrToGoalStatus: '',
  nrrToGoalThreshold: 0,
};
